import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const EditContactsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set editing mode in localStorage and navigate to contacts
    localStorage.setItem('enableEditMode', 'true');
    navigate('/contacts');
  }, [navigate]);

  // This component just redirects, so we can show a brief loading state
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'SF Pro Display, Roboto, sans-serif'
    }}>
      <p>Enabling edit mode...</p>
    </div>
  );
};

export default EditContactsPage; 